import helpers from '@/Mixins/helpers';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  mixins: [helpers],

  components: {
    LoadingButton,
  },

  props: {
    state: Object,
    assetType: Object,
    asset: [String, Number],
    contract: String,
    contractLead: Object,
  },

  data() {
    return {
      saving: false,
      allActionsComplete: false,
      allActionsAccepted: false,
    };
  },

  methods: {
    areAllActionsComplete() {
      const {
        filter,
      } = Array.prototype;

      function checkTagsForDone() {
        const promise = new Promise(((resolve) => {
          window.setTimeout(() => {
            const result = document.querySelectorAll('.action');
            const filtered = filter.call(result, (node) => !node.classList.contains('completed'));
            resolve(filtered.length === 0);
          }, 1000);
        }));
        return promise;
      }


      // eslint-disable-next-line no-return-assign
      checkTagsForDone().then((done) => this.allActionsComplete = done);
    },

    areAllActionsApproved() {
      const {
        filter,
      } = Array.prototype;

      function checkTagsForDone() {
        const promise = new Promise(((resolve) => {
          window.setTimeout(() => {
            const result = document.querySelectorAll('.action');
            const filtered = filter.call(result, (node) => !node.classList.contains('approved'));
            resolve(filtered.length === 0);
          }, 1000);
        }));
        return promise;
      }


      // eslint-disable-next-line no-return-assign
      checkTagsForDone().then((done) => this.allActionsComplete = done);
    },

    areAllActionsAccepted() {
      const {
        filter,
      } = Array.prototype;

      function checkTagsForDone() {
        const promise = new Promise(((resolve) => {
          window.setTimeout(() => {
            const result = document.querySelectorAll('.action');
            const filtered = filter.call(result, (node) => !node.classList.contains('accepted'));
            resolve(filtered.length === 0);
          }, 1000);
        }));
        return promise;
      }

      // eslint-disable-next-line no-return-assign
      checkTagsForDone().then((done) => this.allActionsAccepted = done);
    },
  },
};
